import { Box } from "@mui/material";
import ProductForm from "../../components/ProductForm";

const EditProductFields = ({ businessType, formData, handleInputChange, categories, staffList, previewImage }: any) => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 3, mt: 2 }}>
      <ProductForm
        formData={formData}
        categories={categories}
        staffMembers={staffList}
        businessType={businessType}
        onChange={handleInputChange}
        previewImage={previewImage}
        showErrors={formData.submitted}
      />
    </Box>
  );
};

export default EditProductFields;
